import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";
import {FormControl, Validators} from "@angular/forms";
import * as moment from 'moment-timezone';

@Component({
	templateUrl: './renew_tariff.component.html'
})
export class RenewTariffModalComponent extends BaseSupportModalComponent {
	domainUrl: string;
	siteId: string;
	invoiceNumber: string = '';
	tariffId: string = '';
	dateTo: string = '';
	recurrentProfile: string = '';
	periodType: number = 1;
	customDaysCount: number;
	minCustomDaysCount: number;
	renewRebillDate: boolean = false;

	ngOnInit() {
		this.spreader.base.form = this.form;

		this.form.addControl('dateTo', new FormControl('', [
			this.getStandartValidator('dateTo_format', this.CustomValidators.dateFormat('YYYY-MM-DD'), '"Действителен до" - Неверный(YYYY-MM-DD) формат даты'),
			this.getStandartValidator('dateTo_min', this.CustomValidators.dateNotBeforeToday('YYYY-MM-DD'), '"Действителен до" - Дата не может быть меньше текущей'),
		]));

		this.form.addControl('customDaysCount', new FormControl('', [
			this.getStandartValidator('customDaysCount_maxValue', Validators.max(100 * 365), 'Тариф нельзя продлить больше чем на 100 лет'),
		]));
	}

	async ok() {
		if (confirm(`Вы уверены, что хотите продлить оплату для сайта ${this.domainUrl}?`)) {
			await this.supportService.renewTariff(
				this.siteId,
				this.dateTo,
				this.periodType,
				this.customDaysCount ? this.customDaysCount : 0,
				this.renewRebillDate,
				this.spreader.base.comment
			).toPromise();
			
			this.execute();
		}
	}
}
